import {
  useEffect,
  useState
} from "react";

import MainLayout
from "../../components/layout/MainLayout";

import {
  getStockLedger
}
from "../../api/stockLedgerApi";

import {
  FaHistory,
  FaSearch
}
from "react-icons/fa";

const StockLedger = () => {

  const [ledger,setLedger] =
  useState([]);

  const [search,setSearch] =
  useState("");

  useEffect(()=>{

    loadLedger();

  },[]);

  const loadLedger =
  async()=>{

    try{

      const res =
      await getStockLedger();

      setLedger(
        res.data.data || []
      );

    }
    catch(error){

      console.log(error);

    }

  };

  const filtered =
  ledger.filter(
    item =>
      item.material_name
      ?.toLowerCase()
      .includes(
        search.toLowerCase()
      )
  );

  return(

    <MainLayout>

      <div className="card shadow-sm border-0">

        <div className="card-header bg-white">

          <div className="d-flex align-items-center">

            <FaHistory
              className="me-2 text-primary"
            />

            <div>

              <h5 className="mb-0">
                Stock Ledger
              </h5>

              <small className="text-muted">
                Complete Inventory Movement History
              </small>

            </div>

          </div>

        </div>

        <div className="card-body">

          <div className="row mb-3">

            <div className="col-md-4">

              <div className="input-group">

                <span className="input-group-text">

                  <FaSearch />

                </span>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Search Material"
                  value={search}
                  onChange={(e)=>
                    setSearch(
                      e.target.value
                    )
                  }
                />

              </div>

            </div>

          </div>

          <div className="table-responsive">

            <table className="table table-hover">

              <thead className="table-light">

                <tr>

                  <th>Date</th>
                  <th>Material</th>
                  <th>Transaction</th>
                  <th>Qty In</th>
                  <th>Qty Out</th>
                  <th>Remarks</th>

                </tr>

              </thead>

              <tbody>

                {
                  filtered.map(
                    row => (

                      <tr
                        key={row.id}
                      >

                        <td>

                          {
                            new Date(
                              row.created_at
                            )
                            .toLocaleDateString()
                          }

                        </td>

                        <td>

                          {
                            row.material_name
                          }

                        </td>

                        <td>

                          <span
                            className="badge bg-primary"
                          >

                            {
                              row.transaction_type
                            }

                          </span>

                        </td>

                        <td>

                          <span
                            className="text-success fw-bold"
                          >

                            {
                              row.qty_in
                            }

                          </span>

                        </td>

                        <td>

                          <span
                            className="text-danger fw-bold"
                          >

                            {
                              row.qty_out
                            }

                          </span>

                        </td>

                        <td>

                          {
                            row.remarks
                          }

                        </td>

                      </tr>

                    )
                  )
                }

              </tbody>

            </table>

          </div>

        </div>

      </div>

    </MainLayout>

  );

};

export default StockLedger;